import Vue from 'vue'
import _ from 'lodash'

import { packagePlanType } from '@/lib/global'

export const generateAuthorizationRequestHeader = (token = '') => {
  const chiliSession = Vue.prototype.$session.get('chili')
  const accessToken = _.get(chiliSession, 'access_token', token)
  const authFrom = _.get(chiliSession, 'auth_from', 'tvi')

  return {
    Authorization: `Bearer ${accessToken}`,
    'x-auth-from': authFrom,
  }
}

export const validateBMI = (weight, height, age) => {
  let result
  weight = Number(weight)
  height = Number(height)
  age = Number(age)
  const bmi = weight / Math.pow(height / 100, 2)

  if (age < 16) {
    result = bmi >= 10 && bmi <= 25
  } else {
    result = bmi >= 16 && bmi <= 35
  }

  // console.log('ValidateBMI', { weight, height, age, bmi, result })

  return result
}

export const validateOccupation = (occupationId, occupationList = []) => {
  const occupationData = _.find(occupationList, (data) =>
    _.isEqual(_.parseInt(data.id, 10), _.parseInt(occupationId, 10)),
  )
  const occupationClass = _.get(occupationData, 'class', '')

  if (occupationClass) {
    return occupationClass <= 2
  }

  return false
}

export const validateCitizenNumber = (id) => {
  if (_.isNull(id) || _.size(id) !== 13 || !/^[0-9]\d+$/.test(id)) return false

  const sumCitizen = _.chain(id)
    .take(12)
    .reduce((acc, val, idx) => acc + parseInt(val, 10) * (13 - idx), 0)
    .value()
  const checksum = (11 - (sumCitizen % 11)) % 10

  if (checksum !== parseInt(id.charAt(12))) {
    return false
  }

  return true
}

export const formatInsuranceCoverageCode = (coverage) => {
  const fixCoverageCode = 'IPD+PA'
  const coverageCodeArr = coverage.split('+')
  const coverageArrSize = _.size(coverageCodeArr)

  if (coverageArrSize > 2) {
    const removedIPDCode = coverageCodeArr.slice(2, coverageArrSize)

    const convertedCoverageCode = removedIPDCode.map((code) => {
      const { OPD_DELUXE, OPD_STANDARD } = packagePlanType
      const isEqualOPDStandard = _.isEqual(code, OPD_STANDARD)
      const isEqualOPDDeluxe = _.isEqual(code, OPD_DELUXE)

      if (isEqualOPDStandard || isEqualOPDDeluxe) {
        return 'OPD'
      }
      return code
    })

    return `${fixCoverageCode},${_.join(convertedCoverageCode, ',')}`
  }

  return fixCoverageCode
}

export const convertBase64ToBlob = (b64Data, contentType, sliceSize) => {
  contentType = contentType || ''
  sliceSize = sliceSize || 512

  const byteCharacters = atob(b64Data)
  const byteArrays = []

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize)

    const byteNumbers = new Array(slice.length)
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i)
    }

    const byteArray = new Uint8Array(byteNumbers)

    byteArrays.push(byteArray)
  }

  return new Blob(byteArrays, { type: contentType })
}

export const generatePdfViewerUrl = (url) => `/doc_viewer?docUrl=${url}`
